export default "__VITE_ASSET__DpV0yvy7__"